const warningLabels = {
	titleLabel: {
		label: "Label.MobileCreator.CheckoutWarning.Title",
		default: "Check your product",
	},
	okLabel: {
		label: "Label.MobileCreator.CheckoutWarning.Proceed",
		default: "Proceed to shopping basket",
	},
	okLabelPreview: {
		label: "Label.MobileCreator.CheckoutWarning.Proceed.Preview",
		default: "Continue",
	},
	cancelLabel: {
		label: "Label.MobileCreator.CheckoutWarning.ReturnToProd",
		default: "Return to product",
	},
	messageLabels: {
		beforeWarningsLabel: {
			label: "Label.MobileCreator.CheckoutWarning.Message.BeforeWarnings",
			default: "Your product contains one or more errors:",
		},
		afterWarningsLabel: {
			label: "Label.MobileCreator.CheckoutWarning.Message.AfterWarnings",
			default: "You can adjust your product or continue anyway with these warnings.",
		},
	},
};

const errorLabels = {
	titleLabel: {
		label: "Label.MobileCreator.CheckoutError.Title",
		default: "Errors in your product",
	},
	okLabel: {
		label: "Label.MobileCreator.CheckoutError.ReturnToProd",
		default: "Return to product",
	},
	cancelLabel: undefined,
	messageLabels: {
		beforeWarningsLabel: {
			label: "Label.MobileCreator.CheckoutError.Message.BeforeErrors",
			default:
				"Your product contains one or more error that prevent you from ordering this product:",
		},
		afterWarningsLabel: {
			label: "Label.MobileCreator.CheckoutError.Message.AfterErrors",
			default: "Fix these issues before proceeding to the shopping basket.",
		},
	},
};

export const labels = {
	errorLabels,
	warningLabels,
};
